import { render, staticRenderFns } from "./ConfigReviews.vue?vue&type=template&id=e6594b40&"
import script from "./ConfigReviews.vue?vue&type=script&lang=js&"
export * from "./ConfigReviews.vue?vue&type=script&lang=js&"
import style0 from "./ConfigReviews.vue?vue&type=style&index=0&id=e6594b40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports